import { BiodesixOrderStatus, IOrder, IOrderDetail, IOrderManagerConfig } from '@ispm-client/modules/orders/interfaces';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { get } from 'lodash';
import { OrderService } from '@ispm-client/modules/orders/services/order.service';

@Component({
  selector: 'ispm-order-list',
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderListComponent implements OnInit, OnChanges {
  @Input() orders: Array<IOrder>;
  @Input() listModel: any;
  @Input() config: IOrderManagerConfig;
  @Input() loading: boolean;
  @Input() selectedOrder: IOrder;
  @Input() changeSelectedOrder: (event: any) => void;
  @Input() isEditable: boolean = false;
  @Input() biodesixOrderDetails: Array<IOrderDetail>;
  @Input() canDelete: boolean = false;

  @Output() onChangeOrder: EventEmitter<IOrder> = new EventEmitter();
  @Output() onCreateOrder: EventEmitter<any> = new EventEmitter();
  @Output() onDeleteOrder: EventEmitter<IOrder> = new EventEmitter();
  @Input() disableAddButton: boolean;

  public addBtnLabel: string;

  constructor(private orderService: OrderService) {
  }

  /**
   * Angular lifecycle hooks
   * implements OnInit's `ngOnInit` method
   */
  public ngOnInit() {
    this.addBtnLabel = get(this.config, 'config.listPanel.addBtnLabel', 'Add');
  }

  /**
   * Angular lifecycle hooks
   * implements OnChanges' `ngOnChanges` method
   * @param changes The changed properties
   */
  public ngOnChanges(changes: SimpleChanges) {
    if (changes.biodesixOrderDetails) {
      this.setBiodesixOrderDetails();
    }
  }

  /**
   * Emit create new order emitter
   */
  createOrder() {
    this.onCreateOrder.emit();
  }

  getValue(obj = {}, path = '', defaultValue = '') {
    return get(obj, path, defaultValue);
  }

  changeOrder(order: IOrder) {
    this.onChangeOrder.emit(order);
  }

  /**
   * Emit delete order emitter
   */
  deleteOrder(order: IOrder) {
    this.onDeleteOrder.emit(order);
  }

  canUserAdd() {
    return this.isEditable && get(this.config, 'listPanel.canAdd', false);
  }

  canUserDelete(item: IOrder): boolean {
    const deletePermission = this.isEditable && this.canDelete;
    if (deletePermission && get(this.config, 'listPanel.biodesixCategory', []).includes(get(item, 'category.code'))) {
      return this.biodesixOrderDetails ? this.checkOrderStatus(item) : true;
    }
    return deletePermission;
  }

  /**
   * @description Returns boolean based on selected biodesix orderStatus
   * @param item : Selected order - OrderInformation
   */
  checkOrderStatus(item: IOrder): boolean {
    let order = this.getBiodesixOrders(item);
    return order[0]?.derivedStatus.code ==='IN_PROCESS' ? false:order[0]?.derivedStatus.code ==='ERROR' ? false:order[0]?.derivedStatus.code ==='CANCELED' ? false:order[0]?.derivedStatus.code ==='COMPLETED' ? false : true;  }

  trackByFn(index, item) {
    return item ? item.id : index;
  }

  /**
   * Returns an active Biodesix order
   * @param item An active Biodesix order
   * @returns
   */
  private getBiodesixOrders(item: IOrder): IOrderDetail[] {
    if (item && item.isActive && item.isActive.length > 0) {
      return this.biodesixOrderDetails.filter(order => order.id == item.isActive[0]);
    }
    return [];
  }

  /**
   * Sets additional properties namely, submission date and order status
   * for all the Biodesix orders
   */
  private setBiodesixOrderDetails(): void {
    if ((this.orders && this.orders.length > 0) &&
      (this.biodesixOrderDetails && this.biodesixOrderDetails.length > 0)) {
      this.orders.forEach((value, index, array) => {
        let biodesixOrder: IOrderDetail[] = this.getBiodesixOrders(value);
        if (biodesixOrder.length > 0) {
          if(value.status != biodesixOrder[0].derivedStatus){
            value.status = biodesixOrder[0].derivedStatus;
            // this.orderService.updateOrderStore(value);
          }
          array[index] = {
            ...value,
            biodesixOrderDetails: {
              submissionDate: biodesixOrder[0]?.biodesixOrderingPersonnel?.signedDate,
              orderStatus: BiodesixOrderStatus[biodesixOrder[0].derivedStatus.code]
            }
          };
        }
      });
    }
  }
}
